import gql from 'graphql-tag'

export default gql`query inscriptionSite($slug: String!) {
  inscriptionSite(subpropertySlug: $slug) {
    logo {
      publicUrl
    }
    title
    propertyId
    subpropertyId
    programTabs
    programs {
      rows {
        id
        name
        type
        categories {
          id
          name
        }
        genders
        locations {
          id
          name
        }
        subprograms {
          id
          name
          gender
          status
          category {
            label
            minBirthYear
            maxBirthYear
          }
          pendingInscriptions {
            firstName
            lastName
          }
          competitions
          startDate {
            day
            month
            year
          }
          endDate {
            day
            month
            year
          }
          locations {
            id
            name
            latitude
            longitude
          }
          tryout {
            exist
            startDate {
              day
              month
              year
            }
            endDate {
              day
              month
              year
            }
          }
          competitions
        }
      }
    }
  }
}`
